import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from '@core/services/api.service';
import { FileResponse } from '@core/models/file-response.model';
import { GetNotificationRequest, NotificationResponse, UpdateNotificationRequest } from '@core/models/push-notification.model';
import { ManagerDetail } from '../models/manager-details.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  profileData: EventEmitter<{ name: string, img: string }> = new EventEmitter<{ name: string, img: string }>()

  constructor(private readonly apiService: APIService) { }


  getUserById(id: string): Observable<ManagerDetail> {
    return this.apiService.get<ManagerDetail>(`User/GetUserDetailById?id=${id}`);
  }
  getUserByIdForDispatcher(id: string) {
    return this.apiService.get(`User/GetUserDetailById?id=${id}`);
  }

  editManagerDetail(managerDetail: ManagerDetail): Observable<ManagerDetail> {
    return this.apiService.post<ManagerDetail>('User/UpdateManagerDetailById', managerDetail);
  }
  imageUplaod(imgFormData: FormData): Observable<FileResponse> {
    return this.apiService.post<FileResponse>('User/ImageUpload', imgFormData);
  }
  setProfileData(profileData: { name: string, img: string }): void {
    this.profileData.emit(profileData);

  }
  getProfileData(): Observable<{ name: string, img: string }> {
    return this.profileData.asObservable();
  }
  getNotificationsByUserId(request: GetNotificationRequest, headers?: any): Observable<NotificationResponse> {
  return this.apiService.post<NotificationResponse>('Notification/GetNotificationsByUserId', request, headers);
}
  updateNotificationReadStatus(resuest: UpdateNotificationRequest) {
    return this.apiService.postWithAllResponse('Notification/UpdateNotificationReadStatus', resuest);
  }
  editDriverProfile(req){
    return this.apiService.post('User/EditDriverProfile',req)
  }

  getUserCredit(){
    return this.apiService.get(`BookingSlot/GetUserCredit`)
  }

  deleteUserAccount() {
    return this.apiService.delete('User/DeleteUserAccount');
  }

  resetUserPassword(resuest) {
    return this.apiService.postWithAllResponse('User/ResetPassword', resuest);
  }


 updateGroupUserProfile(request){
  return this.apiService.postWithAllResponse('User/UpdateGroupUserProfile', request)
 }

}
